import {Pipe, PipeTransform} from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';


  @Pipe({
    name: 'unit',
    pure: false
  })
  export class UnitPipe implements PipeTransform {
  
    constructor(private sessionStorage: SessionStorageService) {}
  
    transform(type: string): string {
        let company = this.sessionStorage.retrieve('selectedCompany');
        let unit = "";
        if(company['unit_'+type] != null)
          unit = company['unit_'+type];

        if(unit != null && unit['abbrev'] != null && unit['abbrev'].trim() != "")
          unit = "("+unit['abbrev']+")";
        else
          unit = ""
          
        return unit;
    }
  }


